import * as globals from '../functions/globals'
import * as getters from './getters.js'
import {getLoaderContainer, reloadAjaxCell, reloadTable} from './getters.js'
import * as setters from './setters.js'
import * as filtersModule from './modules/filters'
import * as pagination from './modules/pagination'
import * as expand_rows from './modules/expand_rows'
import * as colvis_reorder from './modules/colvis_reorder'
import qs from 'qs'
import _ from 'lodash'
import _get from 'lodash/get'
import { updateWalletInformation } from '@/utils/dom'
import Vue from 'vue'
import { initTooltips } from '../functions/globals'

import { FixedHeader_positions, FixedHeader_clone, FixedHeader_modeChange } from './fixedHeaderModifier'

import DataTable from "datatables.net";
DataTable(window, $);

import Bs4 from 'datatables.net-bs4'
Bs4(window, $);

import ButtonsBs4 from 'datatables.net-buttons-bs4'
ButtonsBs4(window, $);

import ButtonsColvis from 'datatables.net-buttons/js/buttons.colVis.js'
ButtonsColvis(window, $);

import ColReorderBs4 from  'datatables.net-colreorder-bs4'
ColReorderBs4(window, $);

import FixedHeaderBs4 from 'datatables.net-fixedheader-bs4'
FixedHeaderBs4(window, $);

async function loadFixedSumColumnsModifier() {
    await import('./fixedSumColumnsModifier');
}

window.datatableInstances = {}

window.datatables = {
    filters: null,
    not_wanted_elements: ['select2-search__field', 'search-ajax-checkbox'],
     extends() {
        $.extend(true, $.fn.dataTable.defaults, {
            stateSave: true,
            fixedHeader: true,
            fixedSumColumns: true,
            scrollX: true,
            buttons: [
                {
                    extend: 'colvis',
                    columns: ':not(.noVis)'
                }
            ],
            dom: '<"float-left"B><"processing-back"r>t<"pagination-element"ipl>',
            pagingType: 'simple'
        })
        $.fn.dataTable.Api.register('ask', function (params) {
            $.ajax({
                url: this.ajax.url(),
                type: 'POST',
                dataType: 'json',
                data: {
                    ...this.ajax.params(),
                    custom_filters: qs.stringify(filtersModule.reduceFiltersToValues(_.mapValues(params, (o) => o.value)))
                },
                success: (r) => {
                    window.dispatchEvent(new CustomEvent('recordsFiltered', { detail: r.recordsFiltered }))
                }
            })
        })
        $.fn.dataTable.ext.errMode = 'none'
        $.fn.dataTable.FixedHeader.prototype._positions = FixedHeader_positions
        $.fn.dataTable.FixedHeader.prototype._clone = FixedHeader_clone
        $.fn.dataTable.FixedHeader.prototype._modeChange = FixedHeader_modeChange
         loadFixedSumColumnsModifier()
    },
    init() {
        this.extends()

        document.querySelectorAll('.table-datatable[id]:not(.table-datatable-rendered)').forEach((table) => {
            if ($.fn.DataTable.isDataTable(table)) {
                return
            }

            if ($(table).is(':hidden')) {
                return
            }

            table.classList.add('table-datatable-dont-refresh')

            const container = getters.getContainer(table)

            window.datatableInstances[table.dataset.tableUniqueId] = this.initTable(container, table)
            const instance = window.datatableInstances[table.dataset.tableUniqueId]
            table.classList.add('table-datatable-rendered')
            this.fixProcessingElement(instance, container)
            setters.setProperlyPage(container, instance)

            // Obsługa błędów datatables
            instance.on('error.dt', (e, settings, techNote, message) => {
                if (settings.jqXHR && settings.jqXHR.status === 419) {
                    // Token wygasł
                } else {
                    alert(message)
                }
            })
            // zmienia położenie przycisku widoczności kolumn
            instance.on('preDraw', (e) => {
                if (!$(container).find('.toolbar .toolbar-left').hasClass('colvis-added')) {
                    setters.setNewColvisButton(container)
                }

                // Ukrycie lub pokazanie elementu paginacji
                // if (instance.page.info().pages < 2) {
                //     container.querySelector('.pagination-element').classList.add('d-none');
                // } else {
                //     container.querySelector('.pagination-element').classList.remove('d-none');
                // }
            })
            instance.on('init', () => {
                this.addBackToTopElement(container)

                window.addEventListener('resize', () => {
                    this.addFloatingScrollbarToTable(container)
                })

                this.addFloatingScrollbarToTable(container)

                this.fixPossibilityToSelectRowsFromFixedHeader(table)

                // Dodaje scrollowanie tabeli fixedHeader podczas scrollowania normalniej tabeli
                this.scroll(container, table)

                // pagination.modifyPagination(container, instance);

                expand_rows.hideUnnecessaryIcons()
                instance.columns().iterator('column', function (ctx, idx) {
                    $(instance.column(idx).header()).append('<span class="sort-icon"/>')
                    if (ctx.aoColumns[idx].tooltip) {
                        $(instance.column(idx).header()).append('<i class="position-absolute right-0 top-0 w-100 h-100" data-toggle="tooltip" data-placement="top" title="' + ctx.aoColumns[idx].tooltip_text + '"></i>')
                    }
                })
            })

            instance.on('draw', () => {
                if (instance.context[0].iDraw == 1) {
                    this.dropSelectedRowsForTable(table)
                }

                this.loadCheckboxesIfPossible(table)
                this.setSelectedRowsCounter(table)

                const autoOpenExpandRows = parseInt(container.getAttribute('data-auto-open-expand-rows'))
                if (autoOpenExpandRows > 0 && window.innerWidth >= 768) {
                    container.querySelectorAll('.datatables-expand-data').forEach((item, index) => {
                        if (index < autoOpenExpandRows) {
                            item.click()
                        }
                    })
                }

                setTimeout(() => {
                    reloadAjaxCell(instance, table.id);
                }, 3000);

                //poprawa szerokosci kolumn.
                instance.columns.adjust();
            })

            instance.on('column-reorder', (e, settings, details) => {
                const expandColumns = getters.getExpandColumns(table)

                expand_rows.clearRowsAndAddNewAfterColReorder(instance, container, expandColumns)
                expand_rows.hideUnnecessaryIcons()
            })

            instance.on('order', () => {
                expand_rows.hideUnnecessaryIcons()
            })

            instance.on('column-visibility.dt', (e, settings, column, state) => {
                const cols = $(table).find(`[data-expand-column-index="${column}"]`)

                if (cols) {
                    if (state) {
                        cols.removeClass('d-none')
                    } else {
                        cols.addClass('d-none')
                    }
                }

                if (state) {
                    instance
                        .rows()
                        .data()
                        .each((data, index) => {
                            this.modifyRowIfPossible(instance.row(index).node(), data)
                            this.modifyCellIfPossible(instance.row(index).node(), data)
                        })
                }

                const expandColumns = getters.getExpandColumns(table)

                expand_rows.clearRowsAndAddNewAfterColReorder(instance, container, expandColumns)
            })
            // Nie działa event scroll na body, więc triggerujemy to z main
            $('main').on('scroll', function () {
                //instance.fixedHeader.adjust()
            })

            // Sortowanie w przycisku widoczności kolumn
            colvis_reorder.addColvisReorder(instance, container, table)
        })
    },
    initTable(container, table) {
        const sort = JSON.parse(table.dataset.sortSetting) ? JSON.parse(table.dataset.sortSetting) : [[2, 'asc']]
        let stateSaveParamsTimeout = null

        return $(table).DataTable({
            custom_filters: Vue.observable({}),
            active_filters: Vue.observable({}),
            current_filter: Vue.observable({
                value: 'default',
                label: 'default'
            }),
            processing: true,
            serverSide: true,
            pageLength: parseInt(table.dataset.pageLength),
            lengthMenu: [10, 25, 50, 100, 250],
            colReorder: {
                realtime: false,
                fixedColumnsLeft: table.dataset.fixedColumnsLeft
            },
            columnDefs: [
                {
                    targets: '_all',
                    createdCell: function(td, cellData, rowData, row, col) {
                        $(td).attr('data-column-index', col);
                    }
                }
            ],
            language: getters.getTranslations(container),
            rowId: 'row_id',
            sorting: sort,
            rowCallback: (row, data) => {
                this.modifyRowIfPossible(row, data)
                this.modifyCellIfPossible(row, data)
            },
            /*@TOOD PLS Na razie zostawiam, bo to może być przydatne aby wpiać się w istniejący state object
                stateSaveCallback: (settings, data) => {
                try {
                    (settings.iStateDuration === -1 ? sessionStorage : localStorage).setItem(
                        'DataTables_'+settings.sInstance+'_'+location.pathname,
                        JSON.stringify( data )
                    );
                } catch (e) {}
            },
             */

            stateLoadCallback: (settings, callback) => {
                if (!table.classList.contains('table-datatable-predraw')) {
                    $.ajax({
                        url: route('datatable_states.show', getters.getTableStateId(table).replace(/\//g, '-')),
                        type: 'GET',
                        dataType: 'json',
                        success: (response) => {
                            if (response.filters) {
                                let parsedFilters = JSON.parse(response.filters)
                                setTimeout(() => {
                                    window.dispatchEvent(
                                        new CustomEvent('datatable-filters-loaded-' + table.dataset.tableUniqueId, {
                                            detail: { filters: parsedFilters, apply: false }
                                        })
                                    )
                                }, 1000)
                                callback(parsedFilters)
                            } else {
                                setTimeout(() => {
                                    window.dispatchEvent(
                                        new CustomEvent('datatable-filters-loaded-' + table.dataset.tableUniqueId, {
                                            detail: { filters: {}, apply: false }
                                        })
                                    )
                                }, 1000)
                                callback(null)
                            }
                        }
                    })
                }
            },
            stateLoadParams: (settings, data) => {
                if (data.search.search) {
                    container.querySelector('.table-datatable-global-searching [name="search"]').value = data.search.search
                }
            },
            stateSaveParams: (settings, data) => {
                clearTimeout(stateSaveParamsTimeout)
                stateSaveParamsTimeout = setTimeout(() => {
                    // Czasowe rozwiązanie, czasami mogło się zdarzać, że domyślny state nadpisywał ten z bazy danych i wyświetlało nieprawidłowo dane
                    filtersModule.stateSaveParams(container, data)
                }, 1000)
            },
            ajax: {
                url: getters.getUrl(container),
                type: 'POST',
                data: (requestData) => {
                    requestData.datatable = true
                    const columns = JSON.parse(table.dataset.columns)
                    let instance = {}
                    instance = window.datatableInstances[table.dataset.tableUniqueId]

                    if (instance.state.loaded()) {
                        if (!instance.active_filters) {
                            const state = instance.state.loaded()
                            const current_filter = _get(state, 'current_filter.value')
                            const current_filters = _get(state, `filters.${current_filter}.values`)

                            if (current_filters) {
                                requestData.custom_filters = qs.stringify(filtersModule.reduceFiltersToValues(current_filters))
                            }
                        }

                        instance.state.loaded().columns.forEach((row, key) => {
                            const columnName = requestData.columns[key]['data']
                            const col = columns.filter((item) => {
                                return item.data == columnName
                            })[0]
                            requestData.columns[key]['visible'] = row.visible
                            requestData.columns[key]['exportable'] = col.hasOwnProperty('exportable') ? col.exportable : true
                            requestData.columns[key]['sumable'] = col.hasOwnProperty('sumable') ? col.sumable : false
                            requestData.columns[key]['tooltip'] = col.hasOwnProperty('tooltip') ? col.tooltip : false
                            requestData.columns[key]['tooltip_text'] = col.hasOwnProperty('tooltip_text') ? col.tooltip_text : null
                        })
                    } else {
                        requestData.columns.forEach((row, key) => {
                            const columnName = row.data
                            const col = columns.filter((item) => {
                                return item.data == columnName
                            })[0]
                            requestData.columns[key]['visible'] = col.visible
                            requestData.columns[key]['exportable'] = col.hasOwnProperty('exportable') ? col.exportable : true
                            requestData.columns[key]['sumable'] = col.hasOwnProperty('sumable') ? col.sumable : false
                            requestData.columns[key]['tooltip'] = col.hasOwnProperty('tooltip') ? col.tooltip : false
                            requestData.columns[key]['tooltip_text'] = col.hasOwnProperty('tooltip_text') ? col.tooltip_text : null
                        })
                    }
                    instance
                        .columns()
                        .eq(0)
                        .each((columnIndex) => {
                            requestData.columns[columnIndex]['visible'] = instance.column(columnIndex).visible()
                        })

                    if (instance.active_filters) {
                        requestData.custom_filters = qs.stringify(
                            filtersModule.reduceFiltersToValues(_.mapValues(instance.active_filters, (o) => o.value))
                        )
                    }

                    if (instance.additionalData) {
                        requestData.additional_data = JSON.stringify(instance.additionalData)
                    }
                }
            },
            drawCallback: (instance) => {
                globals.init()
                expand_rows.hideUnnecessaryIcons()

                this.setSelectedRowsCounter(table)

                // this.hideLongTextCells(getCurrentTableInstance(table));

                const selectedAllToggler = container.querySelector('.table-datatable-select-all-toggler[data-selected="true"]')
                if (selectedAllToggler) {
                    const selectAllVisibleCheckboxElement = container.querySelector('.select-all-visible-checkboxes input[type="checkbox"]')
                    selectAllVisibleCheckboxElement.checked = true
                    $(selectAllVisibleCheckboxElement).trigger('change')
                    container.querySelector('[data-selected-rows-counter]').innerText = `(${instance._iRecordsDisplay})`
                }
            }
        })
    },
    pagination() {
        pagination.paginationTimeout()
    },
    searchAjaxCheckbox() {
        let timeout = null

        $('body').on('keyup', '.search-ajax_checkbox', (e) => {
            clearTimeout(timeout)

            timeout = setTimeout(() => {
                //filtersModule.searchAjaxCheckboxMethod(e.target)
            }, 500)
        })
    },
    checkboxes() {
        $('body').on('click', '.table-datatable-select-all-toggler', (e) => {
            const toggler = e.currentTarget
            const info = toggler.parentElement.querySelector('.table-datatable-select-all-info')
            const selected = isTrue(toggler.dataset.selected)
            const instance = getters.getCurrentTableInstance(toggler)
            const container = getters.getContainer(toggler)
            const table = getters.getTable(container)

            if (selected) {
                toggler.setAttribute('data-selected', 'false')
                toggler.innerHTML = `${Translator.__('Zaznacz wszystkie wątki')} (<span class="table-datatable-select-all-all-items-count">${instance.page.info().recordsDisplay}</span>) ${Translator.__('w wynikach wyszukiwania')}.`
                info.innerHTML = `${Translator.__('Zaznaczone są wszystkie wątki')} (<span class="table-datatable-select-all-items-count-on-page">${instance.page.info().recordsTotal}</span>) ${Translator.__('na tej stronie')}.`

                const selectAllVisibleCheckboxElement = container.querySelector('.select-all-visible-checkboxes input[type="checkbox"]')
                selectAllVisibleCheckboxElement.checked = false
                $(selectAllVisibleCheckboxElement).trigger('change')

                container.querySelector('[data-selected-rows-counter]').innerText = '(0)'
            } else {
                toggler.setAttribute('data-selected', 'true')
                toggler.innerHTML = Translator.__('Wyczyść zaznaczenie')
                info.innerHTML = `${Translator.__('Zaznaczone są wszystkie wątki')} (<span class="table-datatable-all-selected-count">${instance.page.info().recordsDisplay}</span>) ${Translator.__('w wynikach wyszukiwania.')}`
                container.querySelector('[data-selected-rows-counter]').innerText = `(${instance.page.info().recordsDisplay})`
            }
            this.dropSelectedRowsForTable(table)
            this.setSelectedRowsCounter(table)
        })

        $('body').on('change', '.select-all-visible-checkboxes input[type="checkbox"]', (e) => {
            const table_id = e.currentTarget.closest('.select-all-visible-checkboxes').dataset.tableId
            const table = document.querySelector(`table#${table_id}`)
            const container = table.closest('.table-datatable-container')
            const instance = getters.getCurrentTableInstance(table)
            const actionSelect = container.querySelector(`.table-datatable-action-selector-container .table-datatable-action-selector`)
            const actionContainer = container.querySelector(`.table-datatable-action-selector-container`)
            const selectAllContainer = container.querySelector('.table-datatable-select-all-items')
            if (e.currentTarget.checked) {
                if (instance.page.info().pages > 1) {
                    selectAllContainer.classList.remove('d-none')
                }

                $(table).find('[name="action_ids[]"]').prop('checked', true)
                $(table).find('[name="expand_action_ids[]"]').prop('checked', true)
                $(table).find('[name="action_ids[]"]').closest('tr').addClass('row-selected')
                if (actionSelect && !isTrue(actionSelect.dataset.actionHasNotRequiredElement)) {
                    actionSelect.classList.remove('disabled')
                }

                if (actionSelect) {
                    actionContainer.querySelectorAll('.dropdown-item[data-option-should-be-disabled]').forEach((option) => {
                        option.classList.remove('disabled')
                    })
                }
            } else {
                selectAllContainer.classList.add('d-none')
                const selectAllToggler = selectAllContainer.querySelector('.table-datatable-select-all-toggler[data-selected="true"]')
                if (selectAllToggler) {
                    selectAllToggler.click()
                    this.dropSelectedRowsForTable(table)
                }

                $(table).find('[name="action_ids[]"]').prop('checked', false)
                $(table).find('[name="expand_action_ids[]"]').prop('checked', false)
                $(table).find('[name="action_ids[]"]').closest('tr').removeClass('row-selected')

                if (actionSelect && !isTrue(actionSelect.dataset.actionHasNotRequiredElement)) {
                    actionSelect.classList.add('disabled')
                }

                if (actionSelect) {
                    actionContainer.querySelectorAll('.dropdown-item[data-option-should-be-disabled]').forEach((option) => {
                        option.classList.add('disabled')
                    })
                }
            }

            table.querySelectorAll('[name="action_ids[]"]').forEach((action) => this.saveSelectedRow(action))
            table.querySelectorAll('[name="expand_action_ids[]"]').forEach((action) => this.saveSelectedRow(action))

            this.setSelectedRowsCounter(table)
        })

        $('body').on('click', '[name="action_ids[]"]', (e) => {
            e.currentTarget.closest('tr').classList.toggle('row-selected')
            const table_id = getters.getTableId(e.currentTarget)
            const table = document.querySelector(`table#${table_id}`)
            const instance = getters.getCurrentTableInstance(table)
            const container = table.closest('.table-datatable-container')
            const actionSelect = container.querySelector(`.table-datatable-action-selector-container .table-datatable-action-selector`)
            const actionContainer = container.querySelector(`.table-datatable-action-selector-container`)
            const selectAllContainer = container.querySelector('.table-datatable-select-all-items')
            const tr = e.currentTarget.closest('tr')
            const trInnerTable = tr.nextElementSibling
            const actionSelected = container.querySelectorAll('[name="action_ids[]"]:checked').length > 0
            const expandSelected = container.querySelectorAll('[name="expand_ids[]"]:checked').length > 0
            if (e.currentTarget.checked) {
                if (actionSelect && !isTrue(actionSelect.dataset.actionHasNotRequiredElement)) {
                    actionSelect.classList.remove('disabled')
                }

                if (actionSelect) {
                    actionContainer.querySelectorAll('.dropdown-item[data-option-should-be-disabled]').forEach((option) => {
                        option.classList.remove('disabled')
                    })
                }
                if (!container.querySelectorAll('[name="action_ids[]"]:not(:checked)').length && instance.page.info().pages > 1) {
                    selectAllContainer.classList.remove('d-none')
                }

                if (trInnerTable && trInnerTable.classList.contains('is-inner-table')) {
                    trInnerTable.querySelectorAll('[name="expand_action_ids[]"]').forEach((expand) => {
                        expand.checked = true
                        expand.closest('tr').classList.add('row-selected')
                        this.saveSelectedRow(expand)
                    })
                    trInnerTable.querySelectorAll('[name="grouped_ids[]"]').forEach((expand) => {
                        expand.checked = true
                        this.saveSelectedRow(expand)
                    })
                }
            } else {
                if (actionSelect && !isTrue(actionSelect.dataset.actionHasNotRequiredElement) && !actionSelected && !expandSelected) {
                    actionSelect.classList.add('disabled')
                }

                if (actionSelect && !actionSelected && !expandSelected) {
                    actionContainer.querySelectorAll('.dropdown-item[data-option-should-be-disabled]').forEach((option) => {
                        option.classList.add('disabled')
                    })
                }

                if (trInnerTable && trInnerTable.classList.contains('is-inner-table')) {
                    trInnerTable.querySelectorAll('[name="expand_action_ids[]"]').forEach((expand) => {
                        expand.checked = false
                        expand.closest('tr').classList.remove('row-selected')
                        this.saveSelectedRow(expand)
                    })
                }
            }

            this.setSelectedRowsCounter(table)
        })

        $('body').on('click', '[name="expand_action_ids[]"]', (e) => {
            const table_id = getters.getTableId(e.currentTarget)
            const table = document.querySelector(`table#${table_id}`)
            const container = table.closest('.table-datatable-container')
            const actionSelect = container.querySelector(`.table-datatable-action-selector-container .table-datatable-action-selector`)
            const innerContainer = e.currentTarget.closest('tr.is-inner-table')
            const innerParentContainer = container.querySelector(`[id="${innerContainer.dataset.parent}"]`)
            const innerParentActionId = innerParentContainer.querySelector('[name="action_ids[]"]')
            const actionContainer = container.querySelector(`.table-datatable-action-selector-container`)
            const actionSelected = container.querySelectorAll('[name="action_ids[]"]:checked').length > 0
            const expandSelected = container.querySelectorAll('[name="expand_ids[]"]:checked').length > 0

            if (e.currentTarget.checked) {
                e.currentTarget.closest('tr').classList.add('row-selected')
                $(innerParentActionId).prop('checked', true)
                this.saveSelectedRow(innerParentActionId)
                if (actionSelect && !isTrue(actionSelect.dataset.actionHasNotRequiredElement)) {
                    actionSelect.classList.remove('disabled')
                }

                if (actionSelect) {
                    actionContainer.querySelectorAll('.dropdown-item[data-option-should-be-disabled]').forEach((option) => {
                        option.classList.remove('disabled')
                    })
                }
            } else {
                e.currentTarget.closest('tr').classList.remove('row-selected')
                $(innerParentActionId).prop('checked', false)
                this.saveSelectedRow(innerParentActionId)
                if (actionSelect && !isTrue(actionSelect.dataset.actionHasNotRequiredElement) && !actionSelected && !expandSelected) {
                    actionSelect.classList.add('disabled')
                }

                if (actionSelect && !actionSelected && !expandSelected) {
                    actionContainer.querySelectorAll('.dropdown-item[data-option-should-be-disabled]').forEach((option) => {
                        option.classList.add('disabled')
                    })
                }
            }
        })
    },
    makeActions() {
        $('body').on('click', '.table-datatable-action-selector-container .dropdown-item, .table-datatable-most-used-actions', (e) => {
            const action = e.currentTarget

            if (action.hasAttribute('data-custom-code')) {
                return
            }

            const actionContainer = action.closest('.table-datatable-action-selector-container')
            if (actionContainer) {
                const actionMainButton = actionContainer.querySelector('.table-datatable-action-selector')
                if (actionMainButton.querySelector('i.fa-circle-notch.fa-spin') === null) {
                    actionMainButton.insertAdjacentHTML('beforeend', `<i class="fa fa-circle-notch fa-spin mx-1" data-datatable-action-loader data-toggle="tooltip" data-trigger="hover" data-title="${Translator.__('tooltip Proszę czekać, trwa przetwarzanie wybranej akcji (tabele)')}"></i>`)
                }
                initTooltips()
            }

            const parent = action.closest('.table-datatable-container')
            const table = getters.getCurrentTableInstance(e.target)
            const url = action.dataset.value
            const allSelected = parent ? isTrue(parent.querySelector('.table-datatable-select-all-toggler').dataset.selected) : false
            const notRequired = action.dataset.hasOwnProperty('notRequireCheckedElements')
            const customParams = action.dataset.hasOwnProperty('addCustomParams')
            const confirmation = action.dataset.hasOwnProperty('confirmationAction')
            const withoutAjax = action.dataset.hasOwnProperty('withoutAjax')
            const additionalData = action.dataset.hasOwnProperty('additionalData') ? JSON.parse(action.dataset.additionalData) : null
            const method = action.dataset.method ? action.dataset.method : 'POST'
            const container = parent ? getters.getContainer(parent) : getters.getContainer(table)
            const tableElement = getters.getTable(container)
            let checkboxes = JSON.parse(sessionStorage.getItem('datatable_checkboxes'))
            checkboxes = checkboxes[tableElement.id] ?? []
            const checked = checkboxes['action_ids[]'] ?? []
            const expandChecked = checkboxes['expand_action_ids[]'] ?? []
            const groupedChecked = checkboxes['grouped_ids[]'] ?? []
            this.initLoader(container)

            if (!url && !action.hasAttribute('data-datatable-export-button')) {
                Toast.error(Translator.__('Musisz wybrać opcję, aby wykonać akcję.'))
                if (actionContainer) {
                    actionContainer.querySelectorAll('.dropdown-item[data-option-should-be-disabled]').forEach((option) => {
                        option.classList.add('disabled')
                    })
                }

                this.removeLoader()

                return false
            }
            if (checked.length == 0 && expandChecked.length == 0 && !notRequired && !allSelected) {
                Toast.error(Translator.__('Musisz zaznaczyć wartości w tabeli, aby wykonać akcję.'))
                if (actionContainer) {
                    actionContainer.querySelectorAll('.dropdown-item[data-option-should-be-disabled]').forEach((option) => {
                        option.classList.add('disabled')
                    })
                }

                this.removeLoader()

                return false
            }

            if (actionContainer) {
                actionContainer.querySelectorAll('.dropdown-item[data-option-should-be-disabled]').forEach((option) => {
                    option.classList.remove('disabled')
                })
            }

            const data = new FormData()

            if (method) {
                data.append('_method', method)
            }

            if (additionalData) {
                Object.entries(additionalData).forEach(([key, row]) => {
                    data.append(`data[${key}]`, row)
                })
            }

            if (allSelected) {
                data.append('select_all_ids', true)
                const excludedCheckboxes = JSON.parse(sessionStorage.getItem('datatable_excluded_checkboxes'))
                if (excludedCheckboxes && excludedCheckboxes[tableElement.id]) {
                    const excludedActionIds = excludedCheckboxes[tableElement.id]['action_ids[]'] ?? []
                    excludedActionIds.forEach((item) => {
                        data.append('exclude_action_ids[]', item)
                    })

                    const excludedExpandActionIds = excludedCheckboxes[tableElement.id]['expand_action_ids[]'] ?? []
                    excludedExpandActionIds.forEach((item) => {
                        data.append('exclude_expand_action_ids[]', item)
                    })
                }
            } else {
                if (checked.length > 0) {
                    checked.forEach((item) => {
                        data.append('action_ids[]', item)
                    })
                }

                if (expandChecked.length > 0) {
                    expandChecked.forEach((item) => {
                        data.append('expand_action_ids[]', item)
                    })
                }

                if (groupedChecked.length > 0) {
                    groupedChecked.forEach((item) => {
                        data.append('grouped_ids[]', item)
                    })
                }
            }

            data.append('table_id', getters.getTable(parent).id)

            if (customParams) {
                data.append('custom_params', JSON.stringify(this.getCustomParams(table)))
            }

            if (additionalData && typeof additionalData['tab_name'] !== 'undefined') {
                data.append('tab_name', additionalData['tab_name'])
            }

            // Tutaj do posta dodajemy również parametry z URL tabeli jeśli będą potrzebne np. w przypadku, gdy będziemy chcieli pobrać rekordy na podstawie zapytania tabeli
            const parameters = JSON.parse(tableElement.dataset.parametersArray)
            Object.entries(parameters).forEach(([key, row]) => {
                data.append(key, row)
            })

            if (!withoutAjax) {
                if (confirmation) {
                    Toast.message({
                        title: Translator.__('tekst Prośba o potwierdzenie (modal potwierdzający)'),
                        message: Translator.__('teskt Jesteś pewny, że chcesz to zrobić? Ta opcja jest nieodwracalna. (modal potwierdzający)'),
                        type: 'danger',
                        mode: {
                            type: 'confirm',
                            confirmed: () => {
                                this.confirmationAjax(url, method, data, table, parent, true, action)
                            },
                            canceled: () => {
                                parent.querySelector('.table-datatable-action-selector').removeAttribute('disabled')
                                document.querySelectorAll('[data-datatable-action-loader]').forEach((item) => item.remove())
                            }
                        }
                    })
                } else {
                    this.confirmationAjax(url, method, data, table, parent, false, action)
                }
            }

            if (!isTrue(action.dataset.actionHasNotRequiredElement) && !action.classList.contains('table-datatable-most-used-actions')) {
                if (additionalData === null || !additionalData.save_checkboxes) {
                    action.classList.add('disabled')
                }
            }

            if (actionContainer) {
                actionContainer.querySelectorAll('.dropdown-item[data-option-should-be-disabled]').forEach((option) => {
                    if (additionalData === null || !additionalData.save_checkboxes) {
                        option.classList.add('disabled')
                    }
                })
            }

            const datatablesActionSelected = new CustomEvent('datatables_action:selected', {
                detail: {
                    instance: table,
                    action: action,
                    url: url,
                    data: data
                }
            })

            action.dispatchEvent(datatablesActionSelected)
            document.dispatchEvent(datatablesActionSelected)
            window.dispatchEvent(datatablesActionSelected)

            parent.querySelector('.select-all-visible-checkboxes input[type="checkbox"]').checked = false
            const selectAllToggler = parent.querySelector('.table-datatable-select-all-toggler[data-selected="true"]')
            if (selectAllToggler) {
                selectAllToggler.click()
            }

            parent.querySelector('.table-datatable-select-all-items').classList.add('d-none')

            if (additionalData === null || !additionalData.save_checkboxes) {
                this.dropSelectedRowsForTable(tableElement)
            }
        })
    },
    confirmationAjax(url, method, data, table, parent, confirmConflictModal = true, action) {
        if (data.get('data[custom_component]') && data.get('data[custom_component_method]')) {
            const component = document.querySelector(data.get('data[custom_component]'))
            if (component) {
                let ids = []
                if (data.get('data[use_expand_action_ids]') !== null) {
                    ids = data.getAll('expand_action_ids[]').length > 0 ? data.getAll('expand_action_ids[]') : data.getAll('action_ids[]')
                } else if (data.get('data[use_grouped_ids]') !== null) {
                    ids = data.getAll('grouped_ids[]').length > 0 ? data.getAll('grouped_ids[]') : data.getAll('action_ids[]')
                } else {
                    ids = data.getAll('action_ids[]')
                }

                component.getVueInstance()[data.get('data[custom_component_method]')](ids, {
                    table_id: data.get('data[table_id]')
                })
                document.querySelectorAll('[data-datatable-action-loader]').forEach((item) => item.remove())
            }
        } else {
            $.ajax({
                url: url,
                type: ['POST', 'PATCH', 'PUT', 'DELETE'].includes(method) ? 'POST' : 'GET',
                dataType: 'json',
                data: data,
                processData: false,
                contentType: false,
                success: (d) => {
                    if (d.conflicts) {
                        let conflictModal = $(parent).parent().find('[data-delete-confirmation-modal]')
                        if (conflictModal.length == 0) {
                            conflictModal = $(parent.closest('.special_tabs_ajax')).parent().find('[data-delete-confirmation-modal]')
                        }
                        const form = conflictModal.find('[data-conflict-delete-modal-form]')
                        conflictModal.find('[data-conflict-delete-modal-title]').html(d.conflict_box_title)
                        conflictModal.find('[data-conflict-delete-modal-description]').html(d.conflict_box_description)
                        form.find('[data-conflict-delete-modal-actions]').val(data.get('action_ids[]'))
                        form.attr('action', d.conflict_box_route)
                        conflictModal.modal('show')
                        if (confirmConflictModal) {
                            this.confirmConflictModal(form, conflictModal, d.conflict_box_route)
                        }
                    } else {
                        updateWalletInformation(d)
                    }

                    const datatablesActionSelected = new CustomEvent('datatables_action:success', {
                        detail: {
                            instance: table,
                            action: action,
                            url: url,
                            data: data
                        }
                    })

                    action.dispatchEvent(datatablesActionSelected)
                    document.dispatchEvent(datatablesActionSelected)
                    window.dispatchEvent(datatablesActionSelected)

                    document.querySelectorAll('[data-datatable-action-loader]').forEach((item) => item.remove())
                }
            })
        }
    },
    confirmConflictModal(form, conflictModal, route) {
        form.removeAttr('action')
        $('body').on('click', '.accept', (e) => {
            e.preventDefault()
            const response = $(form).find('[name="confirmation"]').val()
            if (response.toLowerCase() != 'tak') {
                conflictModal.modal('hide')
                $(form).find('[name="confirmation"]').val(null)
                form.find('[data-conflict-delete-modal-actions]').val(null)
            } else {
                form.attr('action', route)
                form.submit()
            }
        })
    },
    scroll(container, table) {
        table.addEventListener('fixedHeader:show', (e) => {
            let cont = e.detail.container
            $(cont).css('top', `${$('header').outerHeight()}px`)
            const originalTableId = table.dataset.tableUniqueId

            if ($(`#${originalTableId}`).closest('.table-datatable-container').is(':visible')) {
                $(cont).removeClass('d-none')
            } else {
                $(cont).addClass('d-none')
            }
        })
        // Naprawia scroll tabeli lewo prawo tak, aby nagłówek tabeli też to śledził i się przesuwał dla większych tabel
        $('.dataTables_scrollBody').on('scroll', (e) => {
            const table = e.target.querySelector('table')
            const uniqueId = table.dataset.tableUniqueId
            let scroll_left = e.target.scrollLeft

            const fixedTable = $(document).find(`.fixedHeader-container[data-table-unique-id="${uniqueId}"]`)
            fixedTable.scrollLeft(scroll_left)
        })
    },
    initFilter() {
        // Dodaje przycisk włączenia kontenera filtru
        filtersModule.initShowFilterContainer()

        // Dodaje przycisk pokazywania filtru
        //filtersModule.initShowFilter();

        // Dodaje przycisk zamykania filtru
        //filtersModule.initCloseFilter();

        // Dodaje przycisk ukrywania filtrów
        //filtersModule.initHideFilter();

        // Dodaje customowe wyszukiwanie
        filtersModule.initCustomGlobalSearch()

        // Dodaje możliwość usuwania poszczególnych filtrów
        //filtersModule.initClearField();

        // Powoduje zastosowanie filtru i powrót do głównego kontenera filtrów
        //filtersModule.initApplyFilterAndBackToFilterContainer();

        // Przycisk pokazujący filtry
        //filtersModule.initShowRecordsButton();

        // Przycisk czyszczący filtry
        //filtersModule.initClearAllFiltersButton();

        // Działanie enter jako zatwierdzania przycisku "zastosuj"
        //filtersModule.enterOnApplyButton();
    },
    addBackToTopElement(container) {
        const backToTop = $(container).find('.table-datatable-back-to-top')
        $(container).find('.pagination-element').before(backToTop)
        backToTop.append($(container).find('.pagination-element'))
    },
    fixProcessingElement(instance, container) {
        instance.on('processing', (e, settings, processing) => {
            const processingContainer = container.querySelector('.processing-back')

            if (processingContainer) {
                if (processing) {
                    processingContainer.classList.add('d-flex')
                } else {
                    processingContainer.classList.remove('d-flex')
                }
            }
        })
    },
    addFloatingScrollbarToTable(container) {
        $(container).find('.dataTables_scrollBody').floatingScrollbar()
    },
    fixPossibilityToSelectRowsFromFixedHeader(table) {
        table.addEventListener('fixedHeader:show', (e) => {
            const fixedHeaderContainer = e.detail.container
            const child = fixedHeaderContainer.querySelector('thead th:first-child')

            // Naprawia możliwość zaznaczenia wszystkich elementów poprzez checkbox
            if (child && child.classList && !child.classList.contains('was-rendered')) {
                const input = child.querySelector('input')
                const label = child.querySelector('label')
                const random_number = Math.floor(Math.random() * 10 + 1)

                input.id = `${input.id}-${random_number}`
                input.name = `${input.name}-${random_number}`
                label.setAttribute('for', `${label.getAttribute('for')}-${random_number}`)

                child.classList.add('was-rendered')
            }
        })
    },
    showRowDataForMobileDevices() {
        $('body').on('click', '.add-liability-from-liability-preview', (e) => {
            const parentModal = $('body').find('#tenant-liability-form-modal')
            const submit = parentModal.find('[type="submit"]')
            submit.click()
        })

        $('body').on('click', '.table-mobile tbody tr', (e) => {
            // window.stop(); Tym będzie można zablokować przechodzenie na edycję elementu jeśli się kliknie w link, który jest w wierszu
            const clickedElement = e.target
            const tr = e.currentTarget
            const container = getters.getContainer(tr)

            if (container) {
                const mobileModal = container.querySelector('#data-for-mobile-datatables')
                const actionContainer = mobileModal.querySelector('[data-datatables-mobile-action-container]')
                const table = getters.getCurrentTableInstance(tr)
                const data = table.row(tr).data()

                if (
                    clickedElement.closest('button') ||
                    clickedElement.closest('a') ||
                    clickedElement.tagName == 'BUTTON' ||
                    clickedElement.tagName == 'A'
                ) {
                    return
                }

                if (mobileModal && table.context[0].aoColumns) {
                    const filteredColumns = table.context[0].aoColumns.filter((item) => {
                        return !item.hide_for_mobile
                    })

                    const modalItemsContainer = mobileModal.querySelector('.put-datatables-mobile-data-to-modal')

                    if (modalItemsContainer) {
                        modalItemsContainer.innerHTML = ''

                        if (data.action && data.action != '&nbsp;') {
                            actionContainer.innerHTML = ''
                            const actionButtons = $(data.action).find('form, .dropdown-item')

                            actionButtons.each((index, button) => {
                                const icon = button.querySelector('i')
                                let formAction = button.closest('form')

                                if (formAction) {
                                    formAction.classList.add('p-0')
                                }

                                if (icon) {
                                    icon.remove()
                                }

                                button.classList.add('btn', 'btn-primary')
                                button.classList.remove('dropdown-item')

                                actionContainer.insertAdjacentElement('beforeend', formAction ? formAction : button)
                            })

                            Validation.initForms()
                        }

                        filteredColumns.forEach(item => {
                            modalItemsContainer.insertAdjacentHTML('beforeend', `
                            <div class="row">
                                <div class="col-12">
                                    <h3 class="font-weight-normal">${item.title}</h3>
                                </div>
                                <div class="col-12">
                                    ${data[item.data] ? data[item.data] : '-'}
                                </div>
                            </div>
                        `);
                        });

                        $(mobileModal).modal('show')
                    }
                }
            }
        })

        $('body').on('hide.bs.modal', '#data-for-mobile-datatables', (e) => {
            const modal = e.currentTarget
            const modalItemsContainer = modal.querySelector('.put-datatables-mobile-data-to-modal')

            modalItemsContainer.innerHTML = ''
        })
    },
    initBackToTopWorkingButton() {
        $('body').on('click', '.table-datatable-back-to-top a', (e) => {
            const id = $(e.currentTarget).attr('href')
            const anchor = $(`a[id="${id.substr(1)}"]`)
            if (anchor.length) {
                $('html, body').animate({
                    scrollTop: $(`a[id="${id.substr(1)}"]`).offset().top - $('header nav.navbar').outerHeight()
                }, 500);
            }

            return false
        })
    },
    modifyRowIfPossible(row, data) {
        if (data.hasOwnProperty('is_progress_class') && data.is_progress_class) {
            row.querySelectorAll('td').forEach((child) => {
                child.classList.add(data.is_progress_class)
            })
        }
    },
    modifyCellIfPossible(row, data) {
        row.querySelectorAll('.datatable-cell-color').forEach((cell) => {
            if (cell.querySelector('div')) {
                const dataset = cell.querySelector('div').dataset
                if (dataset.datatableCellBorder) {
                    cell.classList.add(dataset.datatableCellBorder)
                }
            }
        })
    },
    setSelectedRowsCounter(table) {
        const container = getters.getContainer(table)
        const instance = getters.getCurrentTableInstance(table)
        const actionSelect = container.querySelector('.table-datatable-action-selector')
        const countOnPage = container.querySelector('.table-datatable-select-all-items-count-on-page')
        const countOnAll = container.querySelector('.table-datatable-select-all-all-items-count')
        const isAllSelected = container.querySelector('.table-datatable-select-all-toggler[data-selected="true"]')
        const allSelectedCount = container.querySelector('.table-datatable-all-selected-count')
        if (actionSelect) {
            const selectedCheckboxes = JSON.parse(sessionStorage.getItem('datatable_excluded_checkboxes'))
            let excludedCounter = 0
            if (selectedCheckboxes && selectedCheckboxes[table.id] && selectedCheckboxes[table.id]['action_ids[]']) {
                excludedCounter = selectedCheckboxes[table.id]['action_ids[]'].length
            }

            let selectedRows = container.querySelectorAll('[name="action_ids[]"]:checked').length
            if (isAllSelected) {
                allSelectedCount.innerText = instance.page.info().recordsDisplay - excludedCounter
                selectedRows = instance.page.info().recordsDisplay - excludedCounter
            }

            if (countOnPage) {
                countOnPage.innerText = selectedRows
            }

            if (countOnAll) {
                countOnAll.innerText = instance.page.info().recordsDisplay - excludedCounter
            }

            const selectedRowsCounterElement = actionSelect.querySelector('[data-selected-rows-counter]')
            if (selectedRowsCounterElement) {
                selectedRowsCounterElement.innerText = `(${selectedRows})`
            } else {
                actionSelect.innerHTML = `${actionSelect.innerText} <span data-selected-rows-counter>(${selectedRows})</span>`
            }
        }
    },
    clearTableAfterAnyAction() {
        $(document).ajaxSuccess((event, request) => {
            if (request.responseJSON) {
                const table = document.querySelector(`.table-datatable[id="${request.responseJSON.table_id}"]`)

                if (table) {
                    table.classList.add('table-datatable-dont-refresh')
                    if (request.responseJSON.estate_ids && request.responseJSON.estate_ids.length > 0) {
                        request.responseJSON.estate_ids.forEach((estateId) => {
                            $eventEmit('update-estates-show', estateId)
                        })
                    }
                }

                if (request.responseJSON.toast && request.responseJSON.toast.title && request.responseJSON.toast.title.table_id) {
                    reloadTable(request.responseJSON.toast.title.table_id, true)
                }

                if (request.responseJSON.event && request.responseJSON.event_obj_id) {
                    $eventEmit(request.responseJSON.event, request.responseJSON.event_obj_id)
                }

                if (request.responseJSON.refresh_nav_header_id) {
                    refreshNavHeader(request.responseJSON.refresh_nav_header_id)
                }

                this.removeLoader()
            }
        })

        $('body').on('show.bs.tab', (e) => {
            const aTab = e.target
            const tab = document.querySelector(`.tab-pane${aTab.hash}`)
            const tables = tab.querySelectorAll('.table-datatable[id]')

            tables.forEach((table) => {
                if (table && table.classList.contains('table-datatable-dont-refresh')) {
                    table.classList.remove('table-datatable-dont-refresh')
                }
            })
        })
        $('body').on('shown.bs.tab', (e) => {
            const aTab = e.target
            const tab = document.querySelector(`.tab-pane${aTab.hash}`)
            const tables = tab.querySelectorAll('.table-datatable[id]')
            tables.forEach((table) => {
                if ($.fn.DataTable.isDataTable(table) && !table.classList.contains('table-datatable-dont-refresh')) {
                    reloadTable(table.id, true)
                }
            })
        })

        $('body').on('custom_tab:show', (e) => {
            const tab = e.detail.tab
            const tables = tab.querySelectorAll('.table-datatable[id]')

            tables.forEach((table) => {
                if (table && table.classList.contains('table-datatable-dont-refresh')) {
                    table.classList.remove('table-datatable-dont-refresh')
                } else if ($.fn.DataTable.isDataTable(table)) {
                    reloadTable(table.id, true)
                }
            })
        })

        $('body').on('hidden.bs.modal', (e) => {
            const table = $('body').find('.table-datatable[id]:visible')[0]

            let clear = false;
            if (table && table.classList.contains('table-datatable-clear')) {
                clear = true;
            }

            if (table && table.classList.contains('table-datatable-dont-refresh')) {
                table.classList.remove('table-datatable-dont-refresh')
            } else if ($.fn.DataTable.isDataTable(table)) {
                reloadTable(table.id, clear)
            }
        })
    },
    hideLongTextCells(instance) {
        const cells = instance.cells().nodes()
        cells.each((cell) => {
            const lines = this.countLines(cell)
            if (lines > 3) {
                const readMoreContainer = document.createElement('div')

                const readMoreTruncated = document.createElement('div')
                readMoreTruncated.innerHTML = cell.innerHTML
                readMoreTruncated.style.height = `50px`
                readMoreTruncated.classList.add('overflow-hidden')

                const readMoreButton = document.createElement('span')
                readMoreButton.classList.add('pointer', 'text-primary')
                readMoreButton.setAttribute('data-toggle', 'popover')
                readMoreButton.innerText = Translator.__('więcej ...')
                readMoreButton.setAttribute('data-content', cell.innerHTML)
                readMoreButton.setAttribute('data-html', 'true')

                readMoreContainer.append(readMoreTruncated)
                readMoreContainer.append(readMoreButton)
                cell.innerHTML = ''
                cell.append(readMoreContainer)
            }
        })
    },
    countLines(originalElement) {
        const element = document.createElement('div')
        element.innerHTML = originalElement.innerHTML
        element.classList.add('remove-after-count-lines')
        element.style.width = `${originalElement.getBoundingClientRect().width - 24}px`
        $('body').append(element)
        const style = window.getComputedStyle(element, null)
        let height = parseInt(style.getPropertyValue('height'))
        const font_size = parseInt(style.getPropertyValue('font-size'))
        let line_height = parseInt(style.getPropertyValue('line-height'))
        const box_sizing = style.getPropertyValue('box-sizing')

        if (isNaN(line_height)) {
            line_height = font_size * 1.2
        }

        if (box_sizing == 'border-box') {
            const padding_top = parseInt(style.getPropertyValue('padding-top'))
            const padding_bottom = parseInt(style.getPropertyValue('padding-bottom'))
            const border_top = parseInt(style.getPropertyValue('border-top-width'))
            const border_bottom = parseInt(style.getPropertyValue('border-bottom-width'))
            height = height - padding_top - padding_bottom - border_top - border_bottom
        }

        $('body').find('.remove-after-count-lines').remove()
        return Math.ceil(height / line_height)
    },
    getPreparedTableUrl(instance, table, additionalParams) {
        const url = table.dataset.ajaxUrl
        const urlObject = new URL(url)
        const params = this.getCustomParams(instance)

        urlObject.searchParams.set('custom_params', JSON.stringify(params))

        if (additionalParams) {
            Object.entries(additionalParams).forEach(([key, row]) => {
                urlObject.searchParams.set(key, row)
            })
        }

        return urlObject.toString()
    },
    getCustomParams(instance) {
        const params = instance.ajax.params()
        const state = instance.state()
        params.columns.forEach((column, key) => {
            const columnName = column.data
            const columnOriginal = instance.context[0].aoColumns.filter((col) => {
                return col.data == columnName
            })[0]
            // Poprawka widoczności kolumn - params oznacza, że pobiera informacje ostatnio przesłane do serwera, a state nie jest tym samym więc o jeden krok zawsze state jest do przodu z informacjami o kolumnach
            params.columns[key].visible = state.columns[key].visible
            params.columns[key].place_order = state.ColReorder[columnOriginal._ColReorder_iOrigCol]
            params.columns[key].exportable = columnOriginal.hasOwnProperty('exportable') ? columnOriginal.exportable : true
        })
        return params
    },
    saveSelectedRowsInSession() {
        $('body').on('change', '[name="action_ids[]"], [name="expand_action_ids[]"]', (e) => {
            this.saveSelectedRow(e.currentTarget)
        })
    },
    saveSelectedRow(target) {
        const container = getters.getContainer(target)
        let checkboxesKey = 'datatable_checkboxes'
        const isSelectedAllToggled = !!container.querySelector('.table-datatable-select-all-toggler[data-selected="true"]')
        if (isSelectedAllToggled) {
            checkboxesKey = 'datatable_excluded_checkboxes'
        }

        let checkboxes = {}
        if (sessionStorage.getItem(checkboxesKey)) {
            checkboxes = JSON.parse(sessionStorage.getItem(checkboxesKey))
        }

        const table = getters.getTable(container)
        let originalActionValue = null
        let expandAdditionalValue = null
        const innerTableTr = target.closest('tr.is-inner-table')
        if (innerTableTr) {
            const originalTr = container.querySelector(`.dataTables_scrollBody tr[id="${innerTableTr.dataset.parent}"]`)
            originalActionValue = originalTr.querySelector('[name="action_ids[]"]').value
            if (target.hasAttribute('data-additional-value')) {
                expandAdditionalValue = target.getAttribute('data-additional-value')
            }
        }
        checkboxes = this.updateCheckboxesInSession(
            checkboxes,
            table.id,
            target.value,
            isSelectedAllToggled ? !target.checked : target.checked,
            target.name,
            originalActionValue,
            expandAdditionalValue
        )

        sessionStorage.setItem(checkboxesKey, JSON.stringify(checkboxes))

        this.setSelectedRowsCounter(table)
    },
    updateCheckboxesInSession(checkboxes, tableId, value, checked, checkboxName, originalActionValue, expandAdditionalValue) {
        let expandAdditionalValueFormatter = ''
        if (expandAdditionalValue) {
            expandAdditionalValueFormatter = `|${expandAdditionalValue}`
        }

        const preparedValue = originalActionValue ? `${originalActionValue}|${value}${expandAdditionalValueFormatter}` : value
        if (checkboxes[tableId] && checkboxes[tableId][checkboxName]) {
            if (checked && !checkboxes[tableId][checkboxName].includes(preparedValue)) {
                checkboxes[tableId][checkboxName] = checkboxes[tableId][checkboxName].concat([preparedValue])
            }

            if (!checked && checkboxes[tableId][checkboxName].includes(preparedValue)) {
                const itemIndex = checkboxes[tableId][checkboxName].indexOf(preparedValue)
                if (itemIndex > -1) {
                    checkboxes[tableId][checkboxName].splice(itemIndex, 1)
                }
            }
        } else {
            if (!checkboxes[tableId]) {
                checkboxes[tableId] = {}
            }

            checkboxes[tableId][checkboxName] = [preparedValue]
        }

        return checkboxes
    },
    loadCheckboxesIfPossible(table) {
        if (sessionStorage.getItem('datatable_checkboxes')) {
            const checkboxes = JSON.parse(sessionStorage.getItem('datatable_checkboxes'))
            if (checkboxes[table.id]) {
                if (checkboxes[table.id]['action_ids[]']) {
                    checkboxes[table.id]['action_ids[]'].forEach((value) => {
                        const actionId = table.querySelector(`[name="action_ids[]"][value="${value}"]`)
                        if (actionId) {
                            actionId.checked = true
                            actionId.closest('tr').classList.add('row-selected')
                        }
                    })
                }

                if (checkboxes[table.id]['expand_action_ids[]']) {
                    checkboxes[table.id]['expand_action_ids[]'].forEach((value) => {
                        const actionId = table.querySelector(`[name="expand_action_ids[]"][value="${value}"]`)
                        if (actionId) {
                            actionId.checked = true
                        }
                    })
                }
            }
        }
    },
    dropSelectedRowsForTable(table) {
        let checkboxes = {}
        let excludedCheckboxes = {}
        if (sessionStorage.getItem('datatable_checkboxes')) {
            checkboxes = JSON.parse(sessionStorage.getItem('datatable_checkboxes'))
        }

        delete checkboxes[table.id]

        sessionStorage.setItem('datatable_checkboxes', JSON.stringify(checkboxes))

        // Wykluczone ID
        if (sessionStorage.getItem('datatable_excluded_checkboxes')) {
            excludedCheckboxes = JSON.parse(sessionStorage.getItem('datatable_excluded_checkboxes'))
        }

        delete excludedCheckboxes[table.id]

        sessionStorage.setItem('datatable_excluded_checkboxes', JSON.stringify(excludedCheckboxes))
    },
    initActionRow() {
        $('body').on('click', '[data-load-action-row]:not([data-action-row-initialized])', (e) => {
            const button = e.currentTarget
            const instance = window.datatableInstances[button.dataset.tableId]
            const data = button.dataset.elementId
            const groupedIds = button.dataset.groupedIds

            $.ajax({
                url: instance.ajax.url(),
                type: 'POST',
                dataType: 'JSON',
                data: {
                    item_id: data,
                    grouped_ids: groupedIds,
                    action_row: true,
                    is_expand: button.classList.contains('is-expand')
                },
                success: (d) => {
                    const dropdown = $(button).data('bs.dropdown')
                    if (dropdown) {
                        dropdown._menu.innerHTML = d.html
                        $(button).dropdown('update')
                    }
                    button.setAttribute('data-action-row-initialized', '')
                    Validation.initForms()
                    initTooltips()
                }
            })
        })
    },
    setDataToPopoverBody() {
        $('body').on('click', '[data-popover-body-route]', (e) => {
            var route = $(e.currentTarget).data('popoverBodyRoute')

            var popover = document.getElementsByClassName('popover-body')

            $.ajax({
                url: route,
                type: 'GET',
                dataType: 'html',
                success: function (result) {
                    popover[popover.length - 1].innerHTML = $(result).html()
                }
            })
        })
    },
    initLoader(element) {
        const tableContainer = getters.getLoaderContainer(element)
        tableContainer.insertAdjacentHTML('beforeend', '<div class="datatable-loader"><div class="datatable-loader__spinner"><i class="fa fa-spinner fa-spin"></i></div></div>')
    },
    removeLoader() {
        const loader = document.querySelector('.datatable-loader')
        if (loader) {
            loader.remove()
        }
    }
}

document.addEventListener('appInitialized', function () {
    $(document).ready(function () {
        datatables.init()

        datatables.initBackToTopWorkingButton()

        // Wyszukiwarka dla szukajki checkboxów
        datatables.searchAjaxCheckbox()

        // Dodaje wsparcie dla inputa zmiany stron
        datatables.pagination()

        // Zaznacza wszystkie checkboxy w tabeli
        datatables.checkboxes()

        // Wykonuje akcję
        datatables.makeActions()

        // Jeśli możliwe, to generuje dodatkowe wiersze z pola expand_data
        expand_rows.showRows()

        // Dodaje obsługę filtrów
        datatables.initFilter()

        // Dodaje możliwość zamknięcia colvis
        colvis_reorder.initCloseColvisButton()

        // Dodaje możliwość wyświetlania modal z danymi dla wersji mobilnej
        datatables.showRowDataForMobileDevices()

        // Resetuje tabelkę w przypadku, gdy zmieniamy tab lub custom-tab tak, że tabela nie jest widoczna (tutaj chyba też trzeba zrobić, że jak zamkniemy modal)
        datatables.clearTableAfterAnyAction()

        datatables.saveSelectedRowsInSession()

        datatables.initActionRow()

        // Dodajemy uzupełnianine body w popover
        datatables.setDataToPopoverBody()
    })
})
